import { orderTotalDisplayStyles as orderStyles } from "@iewccouk/Overrides/Components/OrderTotalDisplay";
import { totalStyles as invoiceStyles } from "@iewccouk/Overrides/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { colorStrings } from "@iewccouk/Utilities/variables";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

const reusableTextStyle = (style?: TypographyPresentationProps): TypographyPresentationProps => ({
    ...style,
    variant: "h3",
    forwardAs: "span",
    css: css`
        ${style?.css}
        margin-bottom: 0;
    `,
});

const reusableHeadingTextStyle: TypographyPresentationProps = {
    variant: "h5",
    forwardAs: "span",
    css: css`
        margin-bottom: 0;
    `,
};

const reusableHorizontalRuleStyle: InjectableCss = {
    css: css`
        border-top: 1px solid ${getColor(colorStrings.commonBorder)};
        margin: 10px 0 15px;
        width: 100%;
    `,
};

/* Invoice Styles */
invoiceStyles.totalLabelText = reusableTextStyle(invoiceStyles.totalLabelText);

invoiceStyles.totalValueText = reusableTextStyle(invoiceStyles.totalValueText);

invoiceStyles.fullWidthGridItem = { width: 12 };

invoiceStyles.headingText = reusableHeadingTextStyle;

invoiceStyles.horizontalRuleWrapper = reusableHorizontalRuleStyle;


/* Order & Order Status Styles */
orderStyles.totalLabel = reusableTextStyle(orderStyles.totalLabel);

orderStyles.totalValue = reusableTextStyle(orderStyles.totalValue);

orderStyles.fullWidthGridItem = { width: 12 };

orderStyles.headingText = reusableHeadingTextStyle;

orderStyles.horizontalRuleWrapper = reusableHorizontalRuleStyle;
